import { createAsyncThunk } from '@reduxjs/toolkit';

import { PreQualificationApi } from 'prequalificationV2/api/PreQualification/PreQualificationApi';
import { CompleteBorrowerRegistration } from 'prequalificationV2/api/PreQualification/preQualificationApi.types';

export const completeBorrowerRegistrationThunk = (preQualificationApi: PreQualificationApi) =>
  createAsyncThunk(
    'prequalification/CompleteBorrowerRegistration',
    async ({
      createBorrower,
      isBorrowerAuthorized,
    }: {
      createBorrower: CompleteBorrowerRegistration;
      isBorrowerAuthorized: boolean;
    }) => {
      const newBorrower = await preQualificationApi.completeBorrowerRegistration(createBorrower);

      // Limited-access token: lets the frontend keep calling prequal endpoints before login, but can't be refreshed.
      if (!isBorrowerAuthorized && newBorrower.isSuccess) {
        localStorage.setItem('token', newBorrower.accessToken);
        localStorage.removeItem('refreshToken');
      }

      return newBorrower;
    },
  );
